import { loginFetch } from './login-api';

export const loginFetchClient = () => {
  const mode = window.yleLeanback.MODE;
  const credentials = window.yleLeanback.clientYleApiCredentials;
  return loginFetch(mode, credentials);
};
